import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Reflection, ReflectionParams, ReflectionSubmitResponse, ReflectionValue } from '../models';

export const reflectionActions = createActionGroup({
    source: 'Reflection',
    events: {
        'Get Reflection': props<{ id: string; params?: ReflectionParams }>(),
        'Get Reflection Success': props<{ id: string; params?: ReflectionParams; payload: Reflection }>(),
        'Get Reflection Not Answered': props<{ id: string; params?: ReflectionParams }>(),
        'Get Reflection Error': props<{ id: string; params?: ReflectionParams; code: number }>(),

        'Submit Reflection': props<{ id: string; value: ReflectionValue }>(),
        'Submit Reflection Success': props<{ id: string; params?: ReflectionParams; payload: ReflectionSubmitResponse }>(),
        'Submit Reflection Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
